import { Helmet } from "react-helmet-async";

const SITE = "https://roxycables.com";

export default function Seo({ title, description, path = "/", noindex = false }) {
    const url = `${SITE}${path}`;
    const fullTitle = title ? `${title} — Roxy Cables` : "Industrial Cables & Wires in Bengaluru — Roxy Cables";
    return (
        <Helmet>
            <title>{fullTitle}</title>
            {description && <meta name="description" content={description} />}
            {noindex ? (
                <meta name="robots" content="noindex, nofollow" />
            ) : (
                <link rel="canonical" href={url} />
            )}
            <meta property="og:title" content={fullTitle} />
            {description && <meta property="og:description" content={description} />}
            <meta property="og:url" content={url} />
        </Helmet>
    );
}
